import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { Utils } from './utils';

@Directive({
    selector: '[safeHtmlContent]',
    standalone: true
})
export class SafeHtmlContentDirective implements AfterViewInit  {
    @Input('safeHtmlContent') _safeHtmlContent: string;

    constructor(private elem: ElementRef<HTMLElement>) {}

    ngAfterViewInit() {
        // silenciando o Sonar: não pode usar bypassSecurityTrust*() mesmo se eu controlar/gerar o conteúdo na aplicação (o que é um absurdo)
        let interval = setInterval(() => {
            if (Utils.isNullOrEmpty(this._safeHtmlContent)) return;

            clearInterval(interval);

            this.elem.nativeElement.innerHTML = this._safeHtmlContent;
        }, 1000);
    }
}
